import React, { useEffect, useState } from 'react';

// Barra de avance del timelapse, al frente de las fotos de la obra. El motor no informa porcentaje, así que se
// estima por tiempo (sube rápido al principio y se frena cerca del final; nunca pasa de 97 % hasta que está listo).
const TAU_SEG = 70;
export const pctEstimado = (seg) => Math.min(97, Math.round(100 * (1 - Math.exp(-seg / TAU_SEG))));

// estimadoSeg: cuánto suele tardar este video (la barra llega a ~92 % en ese tiempo y "Faltan" cuenta hacia ahí).
const ProgresoTimelapse = ({ desde, texto = 'Generando el timelapse de tu obra', listo = false, estimadoSeg = TAU_SEG * 2.5, nota = 'Mientras tanto, mirá cómo avanzó tu obra.', children }) => {
  const [ahora, setAhora] = useState(Date.now());
  useEffect(() => {
    if (listo) return undefined;
    const t = setInterval(() => setAhora(Date.now()), 500);
    return () => clearInterval(t);
  }, [listo]);
  const seg = Math.max(0, (ahora - (desde || ahora)) / 1000);
  const pct = listo ? 100 : Math.max(3, Math.min(97, Math.round(100 * (1 - Math.exp(-seg / (estimadoSeg / 2.5))))));
  const falta = Math.max(0, Math.round(estimadoSeg - seg));
  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center p-4 pointer-events-none">
      <div className="pointer-events-auto w-full max-w-sm rounded-2xl bg-black/60 px-5 py-4 text-center text-white shadow-xl backdrop-blur-sm">
        <p className="text-sm font-semibold">{listo ? '¡Listo! Cargando el video…' : texto}</p>
        <div className="mt-3 flex items-center gap-3">
          <div className="h-2.5 flex-1 overflow-hidden rounded-full bg-white/25" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
            <div className="h-full rounded-full bg-gradient-to-r from-sky-400 to-emerald-400 transition-all duration-500" style={{ width: `${pct}%` }} />
          </div>
          <span className="w-10 text-right text-sm font-bold tabular-nums">{pct}%</span>
        </div>
        {!listo && <p className="mt-2 text-[11px] text-white/75">{falta > 0 ? `Faltan aprox. ${falta < 60 ? `${falta} s` : `${Math.ceil(falta / 60)} min`}` : 'Últimos detalles…'}{nota ? ` · ${nota}` : ''}</p>}
        {children}
      </div>
    </div>
  );
};

export default ProgresoTimelapse;

// Versión chica, debajo del rótulo del timelapse rápido. Sólo se muestra mientras el motor está trabajando de verdad
// (el que la usa la saca si el pedido no cambia de estado en varios minutos o falla): nunca queda una barra trabada.
export const BarraAvance = ({ desde }) => {
  const [ahora, setAhora] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setAhora(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const pct = Math.max(3, pctEstimado(Math.max(0, (ahora - (desde || ahora)) / 1000)));
  return (
    <div className="mt-1.5 flex items-center gap-2" aria-label="Avance del video en alta calidad">
      <div className="h-1 flex-1 overflow-hidden rounded-full bg-white/25" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
        <div className="h-full rounded-full bg-gradient-to-r from-sky-400 to-emerald-400 transition-all duration-700" style={{ width: `${pct}%` }} />
      </div>
      <span className="text-[10px] font-semibold tabular-nums text-white/85">{pct}%</span>
    </div>
  );
};
